import type { AliasToken } from 'antd/es/theme/interface/alias';

/**
 * Esportazione dei token di ant personalizzati
 */
export const uiThemeTokens = {
  // Token personalizzati
  borderRadius: 4,
  // Colore primario
  colorPrimary: '#0066cc',

  colorBorder: '#c2c7cc',
  colorSplit: '#e6e9f2',
  colorBgLayout: '#f2f6fa',
  colorBgContainer: '#ffffff',
  // inseriti per accessibilità
  colorTextPlaceholder: '#757575',
  colorTextDisabled: 'rgba(0, 0, 0, 0.55)',
  // linkDecoration: 'underline',

  lineWidthFocus: 2,
} satisfies Partial<AliasToken>;
